module.exports = __webpack_public_path__ + "img/product2.1edb2827.png";